import React from 'react';
import { useDispatch } from 'react-redux';
import { setShowMiniCart } from '../../Actions/Cart.action';
import MiniCartIcon from './MiniCartIcon';
import { translate } from '../../Services/translation';

const MiniCartButton = () => {
  const dispatch = useDispatch();
  return (
    <button
      onClick={() => dispatch(setShowMiniCart(true))}
      className="flex flex-col items-center gap-1"
    >
      <div className="relative flex items-center justify-center rounded-full bg-headerIconBg p-3 lg:p-2">
        <MiniCartIcon />
      </div>
      <span className="hidden text-xs uppercase lg:block">
        {translate('general.cart')}
      </span>
    </button>
  );
};

export default MiniCartButton;
